import { useTransition } from "react";
import { toast } from "sonner";
import { Icone } from "@/components/Icone";
import type { PendenciaNaTela } from "@/lib/telas/conversas";
import { resolverPendenciaAction } from "@/web/src/acoes";

/**
 * O assistente disse à pessoa que a equipe vai responder. Até alguém marcar
 * como resolvido, este cartão fica no alto da conversa e ela fica em
 * "Aguardando a equipe" na lista — é a promessa que antes se perdia.
 */
export function FaixaPendencia({ telefone, pendencia }: { telefone: string; pendencia: PendenciaNaTela }) {
  const [pendente, iniciar] = useTransition();
  return (
    <div role="status" className="mx-3 mt-3 flex shrink-0 items-start gap-3 rounded-[14px] bg-[var(--color-cartao)] px-4 py-3.5 shadow-cartao md:mx-4">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--color-alerta-fundo)] text-[var(--color-alerta)]">
        <Icone nome="equipe" className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1 text-[13.5px] leading-relaxed">
        <p className="text-sm font-bold text-[var(--color-tinta)]">Aguardando a equipe desde {pendencia.desde}</p>
        {pendencia.motivo.split("\n").map((linha, i) => (
          <p key={i} className="text-[var(--color-tinta)]">
            {linha}
          </p>
        ))}
        <p className="mt-0.5 text-[12.5px] text-[var(--color-fraco)]">
          O assistente disse que a equipe vai responder. Depois de dar o retorno, marque como resolvido.
        </p>
      </div>
      <button
        type="button"
        disabled={pendente}
        onClick={() =>
          iniciar(async () => {
            const r = await resolverPendenciaAction(telefone);
            if (!r.ok) toast.error(r.erro);
            else toast.success("Resolvido. A conversa saiu de “Aguardando a equipe”.");
          })
        }
        className="flex h-8 shrink-0 items-center gap-1.5 rounded-full bg-[var(--color-cartao)] px-3 text-[13px] font-semibold text-[var(--color-tinta)] shadow-botao transition-colors hover:bg-[var(--color-painel)] disabled:opacity-50"
      >
        <Icone nome="check" className="h-4 w-4" />
        {pendente ? "…" : "Resolvido"}
      </button>
    </div>
  );
}
